module.exports = __webpack_public_path__ + "img/indiv2.94a0811e.png";